import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocalStorage } from 'react-use';
import { useGeoIp } from '../../../hooks/useGeoIp';

export const useGeoIpSelector = () => {
  const { countries: items, defaultCountry } = useSelector(
    (state) => state.app.context?.project?.data,
  );

  const [isOpen, setOpen] = useState(false);
  const [popupPosition, setPopupPosition] = useState('bottom');

  const [selectedItem, setSelectedItem] = useLocalStorage('country', defaultCountry.value);
  const toggleDropdown = () => setOpen(!isOpen);
  const { isoCode } = useGeoIp();

  useEffect(() => {
    if (isoCode && (isoCode === 'AU' || isoCode === 'NZ')) {
      return setSelectedItem(
        items?.find((i) => i.value === isoCode)?.value || defaultCountry?.value,
      );
    }
    return setSelectedItem(defaultCountry?.value);
  }, [isoCode]);

  const handleItemClick = (value) => {
    setSelectedItem(value);
    setOpen(false);
  };

  const getCurrentOption = () => {
    return selectedItem
      ? items.find((item) => item.value === selectedItem) ?? { label: '' }
      : { label: '' };
  };
  const getPopupPosition = (ref) => {
    const element = ref.current?.getBoundingClientRect();
    if (!element) {
      return "top";
    }
    const needHeight = element.top + element.height;
    if (needHeight * 2 < window.innerHeight) {
      return 'bottom';
    }
    return 'top';
  };

  return {
    isOpen,
    selectedItem,
    setSelectedItem,
    popupPosition,
    setPopupPosition,
    toggleDropdown,
    handleItemClick,
    getCurrentOption,
    getPopupPosition,
  };
};
